package com.exura.features.plandefinition.domain.model.series

import com.exura.features.plandefinition.domain.model.element.QuestionElement
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * A series that generates question elements.
 * Implements SerializableDomainModel for Firebase storage through BaseAnchoredSeries.
 */
data class SimpleQuestionSeries(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    override val title: String,
    override val description: String,
    override val relativeDay: Int,
    override val elements: List<QuestionElement> = emptyList(),
    private val duration: Int,
    val question: String,
    val options: List<QuestionOption>,
    override val imageUrl: String? = null,
    val estimatedMinutes: Int = 5,
    val reaskEveryDays: Int = 1,
) : BaseAnchoredSeries<QuestionElement>(
    firebaseDocId, firebaseDocPrefix, SeriesType.SIMPLE_QUESTION.spawnType,
) {

    data class QuestionOption(
        val id: String,
        val text: String,
        val responseMessage: String? = null,
        val isResponsePositive: Boolean = true,
    )

    override fun spawnElements(): List<QuestionElement> {
        return (0 until duration step reaskEveryDays).map { dayOffset ->
            println(dayOffset)
            val elementRelativeDay = relativeDay + dayOffset

            QuestionElement(
                relativeDay = elementRelativeDay,
                title = question,
                question = question,
                options = options.map {
                    QuestionElement.Option(it.id, it.text, it.responseMessage, it.isResponsePositive)
                },
                imageUrl = imageUrl,
            )
        }
    }

    override fun durationInDays(): Int = duration
}
